export default __webpack_public_path__ + "static/media/dot-pattern.6274eac2.svg";